export default __webpack_public_path__ + "static/unified2-271c86ccda076248a25e2418521d8125.png";